import { ApiFailureHandler } from "./FailureHandler";
import { ApiSuccessHandler } from "./SuccessHandler";
import "whatwg-fetch";
import { Paths } from "../../Paths";

export const ApiRequest: any = {
    defaultHeaders: {
        "Content-Type": "application/json;charset=UTF-8" // eslint-disable-line
    },
    get: async (
        url: string,
        params: { [key: string]: any },
        successHandler: ApiSuccessHandler,
        failureHandler: ApiFailureHandler,
        headers: { [key: string]: string } = ApiRequest.defaultHeaders
    ) => {
        return await ApiRequest.fetch(url, params, "GET", null, successHandler, failureHandler, headers);
    },
    post: async (
        url: string,
        params: { [key: string]: any },
        body: any,
        successHandler: ApiSuccessHandler,
        failureHandler: ApiFailureHandler,
        headers: { [key: string]: string } = ApiRequest.defaultHeaders
    ) => {
        return await ApiRequest.fetch(url, params, "POST", body, successHandler, failureHandler, headers);
    },
    patch: async (
        url: string,
        params: { [key: string]: any },
        body: any,
        successHandler: ApiSuccessHandler,
        failureHandler: ApiFailureHandler,
        headers: { [key: string]: string } = ApiRequest.defaultHeaders
    ) => {
        return await ApiRequest.fetch(url, params, "PATCH", body, successHandler, failureHandler, headers);
    },
    delete: async (
        url: string,
        params: { [key: string]: any },
        successHandler: ApiSuccessHandler,
        failureHandler: ApiFailureHandler,
        headers: { [key: string]: string } = ApiRequest.defaultHeaders
    ) => {
        return await ApiRequest.fetch(url, params, "DELETE", null, successHandler, failureHandler, headers);
    },
    fetch: async (
        url: string,
        params: { [key: string]: any },
        method: string = "GET",
        body: any = null,
        successHandler: ApiSuccessHandler,
        failureHandler: ApiFailureHandler,
        headers: { [key: string]: string } = ApiRequest.defaultHeaders
    ) => {
        const paramString = Object.entries(params).map((entry) => {
            const key = entry[0];
            const rawValue = entry[1];
            let value = "";
            if (Array.isArray(rawValue)) {
                value = rawValue.map(v => encodeURIComponent(v.toString())).join(",");
            } else {
                value = encodeURIComponent(rawValue.toString());
            }
            return `${key}=${value}`;
        }).join("&");
        return await fetch(
            (paramString !== "") ? `${url}?${paramString}` : url,
            (method === "POST" || method === "PATCH") ?
                {
                    method: method,
                    body: JSON.stringify(body),
                    headers: headers
                } :
                {
                    method: method,
                    headers: headers
                }
        ).then((response) => {
            if (response && response.ok) {
                successHandler(response.clone());
            } else if (response && response.status === 401) {
                window.location.href = Paths.login;
            } else {
                failureHandler(response.clone());
            }
            return ApiRequest.isJsonResponse(response.clone()) ? response.clone().json() : {};
        }
        ).catch(((reason) => {
            //TODO: ちゃんと実装する
            console.log("api call error", reason);
        }));
    },
    isJsonResponse: (response: Response): boolean => {
        if (!(response.headers.get("content-type") || "").includes("application/json")) return false;
        return true;
    }
};
